import { get, post, del, put } from "../common/apiClient";
import { HOSTNAME } from "../common/apiClient";

const PATH_USER = "/user";

const createUser = async (body) => {
  return await post(PATH_USER, body);
};

const updatePassword = async (body) => {
  return await put(PATH_USER + "/update-password", body);
};

const getUsers = async (
  pageNumber,
  limit = 6,
  searchQuery,
  filterPremium,
  filterLocked
) => {
  const params = new URLSearchParams();
  params.set("page", pageNumber);
  params.set("limit", limit);
  if (searchQuery) params.set("q", searchQuery);

  if (filterPremium === "TRUE") params.set("premium", "true");
  if (filterPremium === "FALSE") params.set("premium", "false");

  if (filterLocked === "LOCKED") params.set("locked", "true");
  if (filterLocked === "ACTIVE") params.set("locked", "false");

  const query = `?${params.toString()}`;
  return await get(PATH_USER + query);
};

const deleteUser = async (examId) => {
  return await del(PATH_USER + `/${examId}`);
};

const getUserInfoById = async () => {
  return await get(PATH_USER + `/user-info`);
};

const totalUsers = async () => {
  return await get(PATH_USER + `/total`);
};

const getMaxDevicesConfig = async () => {
  return await get(PATH_USER + `/max-devices`);
};

const updateMaxDevicesConfig = async (maxDevices) => {
  return await put(PATH_USER + `/max-devices`, { maxDevices });
};

const activePremium = async (id, premium) => {
  return await put(PATH_USER + `/premium/${id}`, { premium });
};

const toggleLockUser = async (id) => {
  return await put(PATH_USER + `/lock/${id}`);
};

const uploadUsersFromExcel = async (file) => {
  const formData = new FormData();
  formData.append("excel", file);

  return await post(PATH_USER + "/upload-excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const downloadExcelTemplate = async () => {
  try {
    // Sử dụng fetch trực tiếp để bypass decryptData cho blob response
    const response = await fetch(
      `${HOSTNAME}/api/v2${PATH_USER}/download-excel-template`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to download template");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "user-template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
};

export {
  createUser,
  getUsers,
  updatePassword,
  deleteUser,
  getUserInfoById,
  totalUsers,
  activePremium,
  uploadUsersFromExcel,
  downloadExcelTemplate,
  getMaxDevicesConfig,
  updateMaxDevicesConfig,
  toggleLockUser,
};
